'use strict';
import $ from 'jquery';
import initAccordion from './accordion';

export default class M95 {
    static init() {
        $('.module-m95').each((index, el) => {
            new M95($(el));
        });
    }

    constructor($el) {
        const self = this;
        this.el = $el;
        // The following functionality in m95 executes filtration in M53.
        this.el.find('select').on('select2:select', () => {
            self.updateM53();
        });
        this.el.find('select').on('select2:clear', function (e) {
            self.updateM53();
        });
    }

    updateM53() {
        $('.module-m53').each((index, m53) => {
            const $result = $(m53).find('.results-items');

            const job_filter = $('form[name^="careerFilteration"]').serializeArray()
            let cat = `department=`
            if (job_filter.findIndex(el => el.name === "department") > -1) {
                const parent = $(".departmentFilter .js-example-placeholder-single").closest(".filter-selected")
                $(".departmentFilter .js-example-placeholder-single").select2({
                    allowClear: true,
                    dropdownParent: parent,
                }).val(job_filter.find(el => el.name === "department").value).trigger("change")
                cat = cat + job_filter.find(el => el.name === "department").value
            } else {
                const parent = $(".departmentFilter .js-example-placeholder-single").closest(".filter-selected")
                $(".departmentFilter .js-example-placeholder-single").select2({
                    allowClear: true,
                    dropdownParent: parent,
                }).val(null).trigger("change")
            }
            cat = cat + `&location=`
            if (job_filter.findIndex(el => el.name === "location") > -1) {
                const parent = $(".locationFilter .js-example-placeholder-single").closest(".filter-selected")
                $(".locationFilter .js-example-placeholder-single").select2({
                    allowClear: true,
                    dropdownParent: parent,
                }).val(job_filter.find(el => el.name === "location").value).trigger("change")
                cat = cat + job_filter.find(el => el.name === "location").value
            } else {
                const parent = $(".locationFilter .js-example-placeholder-single").closest(".filter-selected")
                $(".locationFilter .js-example-placeholder-single").select2({
                    allowClear: true,
                    dropdownParent: parent,
                }).val(null).trigger("change")
            }
            cat = cat + "&type=job"
            $.ajax({
                method: 'get',
                url: $(".careerListing .filter-wrapper").data("filter"),
                data: cat
            }).done(function (resp) {
                $result.html(resp);
                initAccordion();
            });
        });
    }
}